import { API, unwrapData } from '../axios-instance'
import { Credentials, MFAResponse, Token } from './types'

export const initiatePasswordLogin = async ({
  credentials,
}: {
  credentials: Credentials | null
}) => {
  return await API.post<Token | MFAResponse>('/identity/passwords/login', credentials, {
    withCredentials: true,
  }).then(unwrapData)
}

export const logout = async () => {
  return await API.post<true>('/identity/logout').then(unwrapData)
}

type InitiatePasswordRecoveryParams = {
  email: string | null
  domain: string
  sendWelcome: boolean
}

export const initiatePasswordRecovery = async (params: InitiatePasswordRecoveryParams) => {
  return await API.post('/identity/passwordIdentities/recovery/', params)
}

type ApplyPasswordResetParams = {
  email: string | null
  code: string | null
  newPassword: string | null
  domain: string
}

export const applyPasswordReset = async (params: ApplyPasswordResetParams) => {
  return await API.post('/identity/passwords/reset', params)
}

type ApplyOfflinePasswordResetParams = {
  employeeId: string
  code: string
  newPassword: string
  domain: string
}

export const applyOfflinePasswordReset = async (params: ApplyOfflinePasswordResetParams) => {
  return await API.post<true>('/identity/passwords/reset/offline', params).then(unwrapData)
}
